export const LOCALES = {
  EN: 'en',
  DE: 'de',
};

export const LOCALES_LABELS = {
  [LOCALES.DE]: 'create-course.german',
  [LOCALES.EN]: 'create-course.english',
};
